import React, { ButtonHTMLAttributes, FC, ReactElement, ReactNode } from 'react';
import { BUTTON_VARIANTS } from '../../constants/button-variants';
import ButtonLinkWrapper from '../../hocs/button-link-wrapper/button-link-wrapper';
import cn from '../../utils/classnames';
import FontAwesomeIcon from '../font-awesome-icon/font-awesome-icon';
import Spinner from '../spinner/spinner';
import './button.scss';

export type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
    children: ReactNode | ReactElement | string;
    className?: string;
    href?: string;
    loading?: boolean;
    size?: 'normal' | 'small';
    success?: boolean;
    variant?: ValueOf<BUTTON_VARIANTS>;
};

const Button: FC<ButtonProps> = ({
    loading = false,
    success = false,
    children,
    variant = '',
    href,
    className = '',
    size,
    type = 'button',
    ...props
}) => {
    return (
        <ButtonLinkWrapper
            className={cn(`custom-button ${variant} ${className}`, { [`size-${size}`]: Boolean(size) })}
            href={href}
            disabled={loading}
            type={type}
            {...props}
        >
            {loading && <Spinner size={15} />}
            {!success && !loading && children}
            {success && !loading && (
                <div className={cn('success-icon', { show: success })}>
                    <span className='position-relative'>
                        <FontAwesomeIcon name='check' theme='black' />
                        {children}
                    </span>
                </div>
            )}
        </ButtonLinkWrapper>
    );
};

export default Button;
